import React from "react";
import { Text } from "@react-pdf/renderer";

export default function LegalFooter({ S }) {
  return (
    <Text style={[S.footer, { textAlign: "center", paddginHorizontal: 20 }]}>
      Documento validado por La Empresa, SISTEMA DE PRODUCCIÓN DESARROLLO Y
      ADMINISTRACIÓN STK PANAMÁ, S. A. con RUC 155704603-2-2021,
      es Proveedor Autorizado Calificado,
      Resolución No. 201-9720 de 12/10/2021.
    </Text>
  );
}